import { Button, Form, Input, Row, Col, Descriptions, notification } from 'antd';
import type { DescriptionsProps } from 'antd';
import { atom } from 'nanostores';
import { useStore } from '@nanostores/react';
import { useEffect } from 'react';
import { DateTime } from 'luxon';
import { User } from '../api/go';

type QueryForm = {
  user_id?: string;
};

interface Info {
  dota_ban_until: string;
  omg_ban_until: string;
  dota_quit: string;
  omg_quit: string;
}

const DefaultData = {
  loading: false,
  user_id: '',
  info: {} as Info,
};

const store = atom(DefaultData);

async function loadInfo(user_id: string) {
  store.set({ ...store.get(), loading: true });

  const info = await User.ladderLimitGet(user_id);

  store.set({
    loading: false,
    info: info,
    user_id: user_id,
  });
}

async function clearLimit() {
  const state = store.get();
  if (!state.user_id) {
    return;
  }

  store.set({ ...store.get(), loading: true });

  await User.ladderLimitClear(state.user_id);

  notification.success({ message: '清除成功' });

  loadInfo(state.user_id);
}

function clearState() {
  store.set(DefaultData);
}

// 展示信用分的历史，当前值，和修改按钮

export default function LadderLimit() {
  useEffect(() => {
    return () => {
      clearState();
    };
  }, []);

  const state = useStore(store);

  const borderedItems: DescriptionsProps['items'] = [
    {
      key: 'dota_ban_until',
      label: 'Dota 封禁时间',
      children: (
        <div>
          {state.info.dota_ban_until ? DateTime.fromSeconds(parseInt(state.info.dota_ban_until, 10)).toFormat('yyyy-MM-dd HH:mm:ss') : ''}
        </div>
      ),
    },
    {
      key: 'dota_quit',
      label: 'Dota 秒退次数',
      children: <div>{state.info.dota_quit || '0'}</div>,
    },
    {
      key: 'omg_ban_until',
      label: 'OMG 封禁时间',
      children: (
        <div>
          {state.info.omg_ban_until ? DateTime.fromSeconds(parseInt(state.info.omg_ban_until, 10)).toFormat('yyyy-MM-dd HH:mm:ss') : ''}
        </div>
      ),
    },
    {
      key: 'omg_quit',
      label: 'OMG 秒退次数',
      children: <div>{state.info.omg_quit || '0'}</div>,
    },
  ];

  return (
    <div>
      <Row>
        <Col span={8}>
          <Form
            name="list"
            layout="horizontal"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            style={{ maxWidth: 600 }}
            onFinish={(values: QueryForm) => {
              if (values.user_id) {
                loadInfo(values.user_id);
              }
            }}
            autoComplete="off"
          >
            <Form.Item<QueryForm> label="User ID" name="user_id">
              <Input disabled={state.loading} />
            </Form.Item>

            <Form.Item label={null}>
              <Button type="primary" htmlType="submit" loading={state.loading}>
                查询
              </Button>
            </Form.Item>
          </Form>
        </Col>
        <Col span={8}>
          <Button type="default" color="danger" disabled={!state.user_id} loading={state.loading} onClick={clearLimit}>
            清除
          </Button>
        </Col>
      </Row>
      <div style={{ margin: '24px 0' }}>
        <Descriptions bordered column={2} items={borderedItems}></Descriptions>
      </div>
    </div>
  );
}
